import * as Yup from 'yup';

// The leaf sits under a category of the reference: at the root level, it would have no parent,
// which the back refuses (the error is shown on the leaf, the field displayed).
export const missionCategorySchemaFields = {
  categoryLeaf: Yup.string()
    .trim()
    .required(
      'Choisissez ou saisissez la catégorie au dernier niveau de la catégorie de mission',
    )
    .test(
      'has-parent-category',
      'Choisissez d’abord une catégorie de mission parente',
      (_leaf, { parent }) =>
        !!(parent as Readonly<{ categoryParentId?: string | null }>)
          .categoryParentId,
    ),
};
